import { render, staticRenderFns } from "./CommentBox.vue?vue&type=template&id=234cf37a&scoped=true"
import script from "./CommentBox.vue?vue&type=script&lang=ts"
export * from "./CommentBox.vue?vue&type=script&lang=ts"
import style0 from "./CommentBox.vue?vue&type=style&index=0&id=234cf37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234cf37a",
  null
  
)

export default component.exports